module.exports = __webpack_public_path__ + "static/dan_band2-c235c99aa838bed8e2f1daba908463c8.png";